import { toastr } from 'react-redux-toastr';
import QueryString from 'query-string';
import { isErrorResponse } from '../../utils/error-handlers';
import {
  CLEAR_BAGGAGE_MANIFEST_PRINT,
  FLAG_GETTING_BAGGAGE_MANIFEST_PRINT,
  GET_BAGGAGE_MANIFEST_PRINT,
} from '../types';
import { BAGGAGE_MANIFEST_PRINT_ENDPOINT } from '../../config/endpoints';
import { DEFAULT_GET_CONFIG } from '../../config/rest';

const flagGettingBaggageManifestPrint = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_BAGGAGE_MANIFEST_PRINT,
    payload: flag,
  });

const parseJsonSafely = async (response) => {
  const text = await response.text();

  if (!text) {
    return null;
  }

  return JSON.parse(text);
};

const getBaggageManifestPrintByItineraryId =
  ({ itineraryId, locationId }) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingBaggageManifestPrint(true));
      const params = {
        locationId,
      };
      const url = `${BAGGAGE_MANIFEST_PRINT_ENDPOINT}/itinerary/${itineraryId}?${QueryString.stringify(
        params,
      )}`;
      const response = await fetch(url, DEFAULT_GET_CONFIG);
      await isErrorResponse(response, null, dispatch);
      const data = await parseJsonSafely(response);
      dispatch({
        type: GET_BAGGAGE_MANIFEST_PRINT,
        payload: data,
      });
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagGettingBaggageManifestPrint(false));
    }
  };

const clearBaggageManifestPrint = () => (dispatch) =>
  dispatch({
    type: CLEAR_BAGGAGE_MANIFEST_PRINT,
  });

export { getBaggageManifestPrintByItineraryId, clearBaggageManifestPrint };
